import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import useStyles from './card-line.styles';

const CardLine = ({ children, className, id }) => {
  const classes = useStyles();
  return (
    <div id={id} className={classNames(classes.item, className)}>
      {children}
    </div>
  );
};

CardLine.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  id: PropTypes.string
};

CardLine.defaultProps = {
  className: null,
  id: null
};

export default CardLine;
